<template>
  <div>
    <div class="guanyuwomen">
      <div class="font-box">
        <div class="font">
         <img src="@/assets/about-us-text.svg" alt="" />
        </div>
      </div>
    </div>
    <div class="about-nav">
      <div class="about-nav-content">
        <div>
          <div
            v-for="(v, i) in navList"
            :key="i"
            :class="i == curIndex ? 'navAcitve' : 'navAcitveNo'"
            @click="navLeft(i, v.linkTo)"
          >
                {{v.name}}
          </div>
        </div>
        <div>
          <span><img src="@/assets/dingwei.png" alt="" /></span>
          <span @click="$router.push('/index?index=0')"
            ><span class="acitvea">首页</span> ></span
          >
          <span
            @click="
               $router.push({path:'/foundation?index=1&title=关于我们&curIndex=0',query:{data:navList[0]}})
            "
          >
            <span class="acitvea">{{ title }}</span> ></span>
          <span class="acitvea">{{
            navList[curIndex] && navList[curIndex].name
          }}</span>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  updated() {
    this.navIndex = this.$route.query.index;
    this.title = this.$route.query.title;
    this.curIndex = this.$route.query.curIndex;
    localStorage.setItem("currentIndex", this.navIndex);
  },
  mounted() {

    this.navIndex = this.$route.query.index;
    this.title = this.$route.query.title;
    this.curIndex = this.$route.query.curIndex;
    localStorage.setItem("currentIndex", this.navIndex);
    this.load()
  },
  data() {
    return {
      records:[],
      title: "",
      navList: [
        { name: "基金会简介", linkTo: "/foundation" },
        { name: "宗旨及使命", linkTo: "/foundation/purpose" },
        { name: "章程制度", linkTo: "/foundation/constitutionSystem" },
        { name: "组织机构", linkTo: "/foundation/organization" },
        { name: "理事会成员", linkTo: "/foundation/councilMembers" },
      ],
      navIndex: "",
      curIndex: "",
    };
  },
  methods: {
    load(){

    },
    go() {
      this.$router.push("/index?index=0");
    },
    go2() {
      this.$router.push("/foundation?index=1&title=关于我们&curIndex=0");
    },
    navLeft(i, path) {
      this.curIndex = i;
      this.$router.push({
        path: path,
        query: {
          index: 1,
          title: this.title,
          curIndex: this.curIndex,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.acitvea {
  &:hover {
    color: #c1141e;
  }
}
.guanyuwomen {
  width: 100%;
  height: 320px;
  background-image: url("../../assets/women2.png");
  background-size: 1920px 320px;
  background-repeat: no-repeat;
  background-position: top center;
}
.font-box {
  width: 1200px;
  height: 320px;
  margin: 0 auto;
  position: relative;
}
.font {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-37px);
}
.font-a {
  font-size: 34px;
  font-family: AlibabaPuHuiTiM, AlibabaPuHuiTiM-Regular;
  font-weight: 500;
  color: #ffffff;
  letter-spacing:4px
}
.font-b {
  font-size: 16px;
  font-family: AlibabaPuHuiTiM, AlibabaPuHuiTiM-Regular;
  font-weight: 500;
  color: #ffffff;
  margin-top: 5px;
}
.navAcitve {
  color: #c1141e;
}
.navAcitveNo {
  color: #333333;
}
.about-nav {
  width: 100%;
  height: 62px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 23, 49, 0.06);
  .about-nav-content {
    width: 1200px;
    height: 62px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div:nth-child(1) {
      display: flex;
      > div:not(:first-child) {
        margin-left: 28px;
      }
    }
    > div:nth-child(2) {
      color: #999999;
      > span:nth-child(1) {
        img {
          vertical-align: text-bottom;
        }
      }
      > span:nth-child(2) {
        margin-left: 9px;
      }
      > span:nth-child(3),
      span:nth-child(4) {
        margin-left: 4px;
      }
    }
  }
}
</style>
